import React, { useState } from 'react';
import Select from 'react-select';

interface Option {
  label: string;
  value: string | number;
}

export interface AppsFieldProps {
  value: string[];
  options: Option[];
  className?: string;
  placeholder?: string;
  isClearable?: boolean;
  isSearchable?: boolean;
  isMulti?: boolean;
  disabled?: boolean;
  onAdd?: (app: any) => void;
  formatOptionLabel?: any;
}

const SelectField = ({
  value,
  options,
  className = '',
  disabled = false,
  isClearable = false,
  isSearchable = false,
  isMulti = false,
  placeholder,
  onAdd,
  formatOptionLabel,
}: AppsFieldProps) => {
  const [inputValue, setInputValue] = useState('');

  const onInputChange = (query, { action }) => {
    // Prevents resetting the input after option has been selected
    if (action !== 'set-value') {
      setInputValue(query);
    }
  };

  const filterOption = (option: any) =>
    !value.includes(option.value) &&
    (inputValue ? option.label.toLowerCase().includes(inputValue.toLowerCase()) : true);

  const render = () => {
    const handleChange = (option: any) => {
      if (onAdd) {
        onAdd(option.value);
      }
    };

    return (
      <Select
        className={`${className}`}
        value={''}
        inputValue={inputValue}
        onInputChange={onInputChange}
        onChange={handleChange as any}
        placeholder={placeholder}
        isDisabled={disabled}
        // @ts-ignore
        options={options}
        isMulti={isMulti}
        // isLoading={isLoading}
        isClearable={isClearable}
        isSearchable={isSearchable}
        formatOptionLabel={formatOptionLabel}
        // components={virtualMenu ? { MenuList: VirtualMenuList } : {}}
        filterOption={filterOption}
        blurInputOnSelect={false}
        closeMenuOnSelect={false}
        styles={{
          control: (base, state) => ({
            ...base,
            background: 'var(--bg2)',
            border: `1px solid ${state.isFocused ? 'var(--gold)' : 'var(--bm)'}`,
            borderRadius: 4,
            boxShadow: 'none',
            minHeight: 28,
            cursor: 'text',
            '&:hover': { borderColor: 'var(--gold)' },
          }),
          menu: (base) => ({
            ...base,
            background: '#13161e',
            border: '1px solid #2a2f3d',
            borderRadius: 4,
            boxShadow: '0 4px 16px rgba(0,0,0,.6)',
            zIndex: 9999,
          }),
          menuList: (base) => ({
            ...base,
            background: '#13161e',
            borderRadius: 4,
            padding: 0,
          }),
          option: (base, state) => ({
            ...base,
            background: state.isFocused ? 'rgba(212,175,55,.12)' : 'transparent',
            color: state.isFocused ? 'var(--gold)' : 'var(--t2)',
            fontFamily: 'var(--mono)',
            fontSize: 11,
            padding: '6px 10px',
            cursor: 'pointer',
          }),
          input: (base) => ({
            ...base,
            color: 'var(--t1)',
            fontFamily: 'var(--mono)',
            fontSize: 11,
            margin: 0,
            padding: 0,
          }),
          placeholder: (base) => ({
            ...base,
            color: 'var(--t3)',
            fontFamily: 'var(--mono)',
            fontSize: 11,
          }),
          singleValue: (base) => ({
            ...base,
            color: 'var(--t1)',
            fontFamily: 'var(--mono)',
            fontSize: 11,
          }),
          valueContainer: (base) => ({
            ...base,
            padding: '2px 8px',
          }),
          dropdownIndicator: (base) => ({
            ...base,
            color: 'var(--t3)',
            padding: '0 6px',
            '&:hover': { color: 'var(--gold)' },
          }),
          clearIndicator: (base) => ({
            ...base,
            color: 'var(--t3)',
            padding: '0 4px',
            '&:hover': { color: 'var(--red)' },
          }),
          indicatorSeparator: () => ({ display: 'none' }),
          noOptionsMessage: (base) => ({
            ...base,
            color: 'var(--t3)',
            fontFamily: 'var(--mono)',
            fontSize: 11,
          }),
          loadingMessage: (base) => ({
            ...base,
            color: 'var(--t3)',
            fontFamily: 'var(--mono)',
            fontSize: 11,
          }),
        }}
      />
    );
  };
  return render();
};

export default SelectField;
